import $ from 'jquery';
import Isotope from 'isotope-layout';
import Scrolling from '../libs/Scrolling';

let IsotopeStuff = {

    iso: null,
    $filtres: null,
    filtresSlug: [],
    pageType: null,
    firstClick: true,
    showLimit: 6,
    initialShowLimit: 6,
    addSize: 6,

    init: function () {
        if ($('body').hasClass('page-template-hub-nos-navires')) {
            this.pageType = 'ship';
            this.initIsotope();
            this.loadMoreInit();
        }

        if ($('body').hasClass('page-template-hub-guides')) {
            this.pageType = 'guide';
            this.initIsotope();
            this.loadMoreInit();
        }
    },
    initIsotope() {

        this.iso = new Isotope('.grid', {
            // options
            itemSelector: '.grid-item',
            percentPosition: true,
            stagger: 100,
            // transitionDuration: 300,
            masonry: {
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer'
            },
            // fade in from bottom
            visibleStyle: {
                opacity: 1,
                transform: 'translateY(0)',
            },
            hiddenStyle: {
                opacity: 0,
                transform: 'translateY(50px)',
            },
        });


        this.$filtres = $('.filtres li');

        // Get slugs filter in a array for indexOf
        this.$filtres.each((index, el) => {
            this.filtresSlug.push(el.dataset.filter);
        });

        this.$filtres.on('click', function () {

            var filterValue = $(this).attr('data-filter');
            location.hash = 'filter=' + encodeURIComponent(filterValue);
        });

        $(window).on('hashchange', () => {
            this.showLimit = this.initialShowLimit;
            this.updateIsotope();
        });

        this.updateIsotope();

    },
    updateIsotope() {

        var filterValue = this.getHashFilter();
        this.updateClasses(filterValue);
        let count = 0;

        this.iso.arrange({
            filter: function (lol, element) {

                if (filterValue === '*') {
                    count = count + 1;
                    if (count <= IsotopeStuff.showLimit) {
                        return true;
                    }
                }

                if ($(element).hasClass(filterValue.substring(1))) {
                    count = count + 1;
                }

                return $(element).hasClass(filterValue.substring(1)) && count <= IsotopeStuff.showLimit;
            }
        });

        this.toggleLoadMoreButton(count);
    },
    updateClasses(filterValue) {

        if (this.pageType === 'ship') {
            this.$filtres.removeClass('active');
            $('.filtres li' + '[data-filter="' + filterValue + '"]').addClass('active');
        }

        if (this.pageType === 'guide') {
            this.$filtres.find('a').addClass('outline');
            $('.filtres li' + '[data-filter="' + filterValue + '"]' + ' a').removeClass('outline');
        }


    },
    getHashFilter() {
        // get filter=filterName
        var matches = location.hash.match(/filter=([^&]+)/i);
        var hashFilter = matches && matches[1];
        if (hashFilter === null || this.filtresSlug.indexOf(hashFilter) == -1) {
            hashFilter = '*';
        }
        return hashFilter && decodeURIComponent(hashFilter);
    },
    loadMoreInit() {
        $('.wrapper .loadmore').on('click', () => {

            this.showLimit = this.showLimit + this.addSize;
            this.updateIsotope();

        });
    },
    toggleLoadMoreButton(count) {

        if (this.showLimit >= count) {
            $('.wrapper .loadmore').fadeOut(400);
        } else {
            $('.wrapper .loadmore').fadeIn(400);
        }


    }
};

export default IsotopeStuff;


// WEBPACK FOOTER //
// ./assets/js/libs/IsotopeStuff.js